import React from "react";

import { StyledWrapper } from "./breadcrumbs.style";

const Breadcrumbs = ({ data }) => {
  const breadcrumbs = data.map((breadcrumb, index) => {
    const current = index === data.length - 1;

    return (
      <li className={`breadcrumb-item ${current ? "active" : ""}`} key={index}>
        {!current ? (
          <a href={breadcrumb.path}>{breadcrumb.label}</a>
        ) : (
          breadcrumb.label
        )}
      </li>
    );
  });

  return (
    <StyledWrapper className="row">
      <div className="col-12">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb m-0">{breadcrumbs}</ol>
        </nav>
      </div>
    </StyledWrapper>
  );
};

export default Breadcrumbs;
